import React from 'react';

export default ({ title, onClose }) => (
  <div className="modal-header">
    {onClose && <button type="button" className="close" onClick={onClose}>&times;</button>}
    <h4 className="modal-title">{title}</h4>
  </div>
);
